import axios from 'axios'
import { APP_CONSTANT } from '../constants'
import UserService  from '../services/user/user.service'

const getLWSIDBearerToken = (): string => {
  const cookies = document.cookie
  const cookieList = cookies.split(/;\s?/)
  const lwsid = cookieList.find((c) => c.substring(0, 5) === 'lwsid') || ''

  return decodeURIComponent(lwsid.split('=')[1])
}

interface IRPC {
  method: string
  params: any[]
}

let authenticated = true

type ErrorFunction = (error: string | object | (object | string)[]) => void
interface ApiInterface {
  authenticate(): Promise<void>
  isAuthenticated(): boolean

  rpc(path: string, body: IRPC, errorFn?: ErrorFunction): Promise<any>;

  fakeCall(path: string, body: IRPC, errorFn: ErrorFunction | undefined, result?: any): Promise<any>;
}

const triggerErrorBoundary = (
  e: string | object | (string | object)[]
): void => {
  throw e
}
const userService = new UserService()
const ApiService = (): ApiInterface => {
  const authenticate = async (): Promise<void> => {
    authenticated = userService.isValidToken()
  }

  const isAuthenticated = (): boolean => authenticated
  const rpc = async (
    path = '',
    body: IRPC,
    errorFn?: ErrorFunction
  ): Promise<any> => {
    const axiosConfig = {
      headers: {
        Authorization: `Bearer ${getLWSIDBearerToken()}`,
        'content-Type': 'application/json'
      }
    }

    try {
      const response = await axios.post(
        APP_CONSTANT.RPC_PATH,
        {
          m: path ? `${path}.${body.method}` : body.method,
          p: body.params
        },
        axiosConfig
      )

      if (response.status > 399) {
        if (errorFn) {
          return errorFn(response.data)
        }

        return triggerErrorBoundary(response.data.message)
      }
      if (response.data.status) {
        if (errorFn) {
          return errorFn(response.data)
        }

        return triggerErrorBoundary(response.data.message)
      }

      return response.data
    } catch (e) {
      if (errorFn) {
        errorFn(e)
      } else {
        triggerErrorBoundary(e)
      }

      return e
    }
  }

  const fakeCall = async (
    path: string,
    body: IRPC,
    errorFn: ErrorFunction | undefined,
    results?: any
  ): Promise<any> => {
    console.log(path, body, !!errorFn)

    return { p: [null, { results }] }
  }

  return {
    ...axios,
    authenticate,
    isAuthenticated,
    rpc,
    fakeCall
  }
}

export default ApiService
